import Vue from 'vue'
import Router from 'vue-router'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import {
  getServiceLocationInfo,
  isPreRenderer,
  setServiceLocationInfo,
  isEnableBottomTabView,
} from '@/common/util/common'
import { getServiceLocation } from '@/common/api/api.service'
import homeRoutes from '@/router/homeRoutes'
// import categoryRoutes from '@/router/categoryRoutes'
import gnbRoutes from '@/router/gnbRoutes'
import accountRoutes from '@/router/accountRoutes'
import redirectRoutes from '@/router/redirectRoutes'
import customerRoutes from '@/router/customerRoutes'
import eventRoutes from '@/router/eventRoutes'
import voucherRoutes from '@/router/voucherRoutes'
import listRoutes from '@/router/listRoutes'
import myRoutes from '@/router/myRoutes'
import searchRoutes from '@/router/searchRoutes'
import otherRoutes from '@/router/otherRoutes'
import agreementRoutes from '@/router/agreementRoutes'
import baseballRoutes from '@/router/baseballRoutes'
import notFoundRoutes from '@/router/notFoundRoutes'
import store from '@/store'
import promotionRoutes from '@/router/promotionRoutes'
Vue.config.performance = process.env.NODE_ENV !== 'production'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...homeRoutes,
    // ...categoryRoutes,
    ...gnbRoutes,
    ...myRoutes,
    ...searchRoutes,
    ...accountRoutes,
    ...customerRoutes,
    ...eventRoutes,
    ...voucherRoutes,
    ...agreementRoutes,
    ...listRoutes,
    ...promotionRoutes,
    ...redirectRoutes,
    ...otherRoutes,
    ...baseballRoutes,
    ...notFoundRoutes,
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      let prevScrollHeight = 0
      let debounceTimer = setInterval(() => {
        if (savedPosition.y < document.documentElement.scrollHeight) {
          if (prevScrollHeight < document.documentElement.scrollHeight) {
            prevScrollHeight = document.documentElement.scrollHeight
          } else if (
            prevScrollHeight >= document.documentElement.scrollHeight
          ) {
            window.scrollTo(0, savedPosition.y)
            clearInterval(debounceTimer)
          }
        }
      }, 100)
    } else {
      window.scrollTo(0, 0)
    }
    // return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (get(to, 'query.routertest', 'n') === 'y') {
    window.opener.checker(to.name, get(to, 'query.idx', 0))
    next()
  }
  if (isPreRenderer()) {
    next()
  } else {
    const routeName = (route) => {
      return get(route, 'name', '') === null ? '' : get(route, 'name', '')
    }
    if (routeName(to) === 'player') {
      store.commit('setBeforeEnterPlayerPath', from.fullPath)
    }
    if (!isEnableBottomTabView(routeName(to))) {
      store.commit('hideNavigationMenu')
    } else {
      store.commit('showNavigationMenu')
    }
    const isService = get(getServiceLocationInfo(), 'isservice', 'y') === 'y'
    if (to.name === 'waitingService') {
      next()
    } else if (!isService) {
      next('/waiting/service')
    } else {
      const locationInfo = getServiceLocationInfo()
      const credential = utils.cookies.getCredential()
      if (locationInfo === null && credential !== 'none') {
        getServiceLocation(credential).then((serviceLocation) => {
          const locationInfo = get(serviceLocation, ['data'], false)
          if (locationInfo) {
            setServiceLocationInfo(locationInfo)
            next()
          }
        })
      } else {
        next()
      }
    }
  }
})

export default router
